import React from 'react';
import classes from './not-found.module.scss';

const NotFound = () => {
  return (
    <div className={classes.wrapper}>
      <div className={classes.row}>
        <h2>Oops!</h2>
      </div>
      <div className={classes.row}>
        <h1>4</h1>
        <img src="/assets/404.png" alt="donut" />
        <h1>4</h1>
      </div>
    </div>
  );
};

export default NotFound;
